import { render } from "./ToggleButton.vue?vue&type=template&id=12faf526&scoped=true&ts=true"
import script from "./ToggleButton.vue?vue&type=script&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=12faf526&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12faf526"]])

export default __exports__